/* global $, google */
import 'aos/dist/aos.css'
import '../css/style.css'

import AOS from 'aos'
import Rellax from 'rellax'
import Glide from '@glidejs/glide'
import './jquery.inview.min.js'
import './scrolltopcontrol.js'

import mapPin from '../img/map_pin.png'

/* GOOGLE MAPS */
window.initializeGoogleMaps = function () {
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: 15,
    scrollwheel: false,
    center: new google.maps.LatLng(48.20164408, 16.38886238)
  })

  /* eslint-disable no-new */
  new google.maps.Marker({
    position: map.getCenter(),
    icon: mapPin,
    map: map
  })
}

/* ANIMATION HELPER */
function formatNumber (value) {
  value = value || 0 // safe guard against null & undefined
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

const raf =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (callback) { return setTimeout(callback, 100) }

function debouncedInvocationOnScroll (callback) {
  var latestKnownScrollY = 0
  var ticking = false

  $(window).on('scroll', function () {
    latestKnownScrollY = window.scrollY

    if (!ticking) {
      ticking = true

      raf(function () {
        ticking = false
        callback(latestKnownScrollY)
      })
    }
  })
}

/* DOCUMENT READY */
$(function () {
  /* Set min-height to avoid 100vh bug on mobiles */
  const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  $('.home').css('height', `${height}px`)

  /* NAVBAR */
  const $siteNavigation = $('.site-navigation')
  function setNavBarClass (scrollY) {
    if (scrollY > 70) {
      $siteNavigation.addClass('navbar-fixed')
    } else {
      $siteNavigation.removeClass('navbar-fixed')
    }
  }

  setNavBarClass(window.scrollY)
  debouncedInvocationOnScroll(setNavBarClass)

  /* COUNTER */
  $('.counter').one('inview', function () {
    $(this)
      .find('.counter-num')
      .each(function (el) {
        const $this = $(this)
        const endValue = parseInt($this.text())

        $({ counter: 0 }).animate(
          { counter: endValue },
          {
            duration: 2000,
            easing: 'swing',
            step: function () {
              $this.text(formatNumber(Math.ceil(this.counter)))
            },
            complete: function () {
              $this.text(formatNumber(endValue))
            }
          }
        )
      })
  })

  /* PARALLAX EFFECT */
  new Rellax('.rellax') // eslint-disable-line no-new

  /* ANIMATE ON SCROLL */
  AOS.init()

  /* PARTNER LOGOS */
  new Glide('.glide', {
    type: 'carousel',
    autoplay: 5000,
    perView: 5,
    breakpoints: {
      1199: { perView: 4 },
      991: { perView: 3 },
      767: { perView: 2 },
      429: { perView: 1 }
    }
  }).mount()
})
